<template>
  <div class="returnDetail-wrap-container">
    <van-nav-bar
      title="退回详情"
      left-arrow
      @click-left="goBack"
      :class="[
        'rewrite-am-navbar-light',
        not_iphonex ? 'notrem-rewrite-am-navbar-light-notiphonex' : '',
        iphonex && !not_iphonex ? 'notrem-rewrite-am-navbar-light-iphonex' : '',
      ]"
    />
    <div
      :class="[
        'returnDetail-wrap',
        not_iphonex ? 'notrem-returnDetail-wrap-notiphonex' : '',
        iphonex && !not_iphonex ? 'notrem-returnDetail-wrap-iphonex' : '',
      ]"
    >
      <div class="return-top-box">
        <div class="return-status">
          <span
            :class="[status == 1 ? 'return_ing_icon' : 'return_success_icon']"
          ></span>
          <label class="return-status-text">{{
            status == 1 ? "退回中" : "退回成功"
          }}</label>
        </div>
        <div v-if="status != 1" class="return-note">
          感谢您对学而思1对1的支持
        </div>
      </div>
      <div class="card-box">
        <h4 class="card-box-title">
          <span>退回教材</span>
          <label class="badge">共{{ goodsName.length }}件</label>
        </h4>
        <div class="info-list-box1">
          <template v-for="(item, index) in goodsName">
            <p
              v-if="index > 1"
              :style="{ display: infoSlideOpen ? 'block' : 'none' }"
              :key="index"
            >
              {{ item }}
            </p>
            <p v-else style="display: block" :key="index">{{ item }}</p>
          </template>
          <p v-if="goodsName.length > 2">
            <span
              v-if="infoSlideOpen"
              class="silde-box"
              @click="infoSlideToggle"
              >收起<span class="silde-down-icon"></span
            ></span>
            <span v-else class="silde-box" @click="infoSlideToggle"
              >展开<span class="silde-up-icon"></span
            ></span>
          </p>
        </div>
      </div>
      <div class="card-box">
        <ul class="process-list">
          <li class="process-one">
            <h5 class="process-title">
              <span class="logistics_return_icon"></span>
              <span class="process-title-text success flex-between">
                <label>发起退回</label>

                <a v-if="status == 1" @click="editExpressInfo">
                  <span>修改快递信息</span>
                  <span class="right-row"></span>
                </a>
              </span>
            </h5>
            <div class="process-info">
              <p>
                <label>快递单号</label><span>{{ expressId }}</span>
              </p>
              <p>
                <label>快递公司</label><span>{{ expressCompanyDesc }}</span>
              </p>
              <p>
                <label>联系人</label><span>{{ consignee }}</span>
              </p>
              <p>
                <label>联系电话</label><span>{{ consigneePhone }}</span>
              </p>
              <p class="font-size-min">
                {{ createTime }}
              </p>
            </div>
          </li>
          <li class="process-two">
            <h5 class="process-title">
              <span
                :class="[
                  status == 1
                    ? 'logistics_collect_grey'
                    : 'logistics_collect_red',
                ]"
              ></span>
              <span
                :class="['process-title-text', status == 1 ? '' : 'success']"
              >
                <label>商家收货</label>
              </span>
            </h5>
            <div class="process-info">
              <p v-if="status != 1" class="font-size-min">{{ successTime }}</p>
            </div>
          </li>
          <li class="process-three">
            <h5 class="process-title">
              <span
                :class="[
                  status == 1
                    ? 'logistics_collect_grey'
                    : 'logistics_collect_red',
                ]"
              ></span>
              <span
                :class="['process-title-text', status == 1 ? '' : 'success']"
              >
                <label>完成退回</label>
              </span>
            </h5>
            <div class="process-info">
              <p v-if="status != 1" class="font-size-min">{{ successTime }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="card-box">
        <h4 class="card-box-title flex-between">
          <span>退回地址</span>
        </h4>
        <div class="return-address-box">
          <h5 class="return-address-title">
            <span class="return-address-name">{{ returnName }}</span>
            <span>{{ returnPhone }}</span>
          </h5>
          <div class="info-list-box2">
            <p>{{ returnAddress }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import { formatDate } from "../../utils/utils";
import appUtil from "../../utils/appUtil";

export default {
  name: "returnDetail",
  data() {
    return {
      status: 1,
      goodsName: [],
      infoSlideOpen: false,
      expressId: "",
      expressCompanyDesc: "",
      consignee: "",
      consigneePhone: "",
      createTime: "",
      successTime: "",
      returnName: "",
      returnPhone: "",
      returnAddress: "",
      tab: "",
      mrbNum: "",
      not_iphonex: window.navigator.userAgent.includes("not_iphonex"),
      iphonex: window.navigator.userAgent.includes("iphonex"),
    };
  },
  components: {},
  computed: {},
  created() {
    //顶部导航透明
    // if (window.mobile && window.mobile.isShowNavigation) {
    //   window.mobile.isShowNavigation(false);
    // }
    let isApp = new appUtil().isApp();
    if (isApp == "android" || isApp == "ios") {
      window.dhsdk.isShowNavigation({
        show: false,
      });
    }
  },
  mounted() {
    this.tab = this.$route.query.tab ? this.$route.query.tab : "";
    this.mrbNum = this.$route.query.mrbNum ? this.$route.query.mrbNum : "";
    this.getInfoDetail();
    this.getReturnAddress();
    window.scrollTo(0, 0);
  },
  methods: {
    ...mapMutations({
      changeLoading: "changeLoading",
    }),
    goBack() {
      window.location.replace(
        `${location.origin}${location.pathname}#/myPackage?tab=${this.tab}`
      );
    },
    //展开收起
    infoSlideToggle() {
      this.infoSlideOpen = !this.infoSlideOpen;
    },
    //修改快递信息
    editExpressInfo() {
      this.$router.push({
        path: "/expressInfoEdit",
        query: {
          mrbNum: this.mrbNum,
        },
      });
    },
    //数据初始化
    getInfoDetail() {
      return new Promise((resolve) => {
        this.changeLoading(true);
        this.$api.my
          .getReturnInfoDetail({
            mrbNum: this.mrbNum,
          })
          .then((res) => {
            this.changeLoading(false);

            if (res.ret) {
              this.goodsName = res.data.goodsName;
              this.expressId = res.data.expressId;
              this.expressCompanyDesc = res.data.expressCompanyDesc;
              this.consignee = res.data.consignee;
              this.consigneePhone = res.data.consigneePhone;
              this.status = res.data.status;
              this.createTime = res.data.createTime
                ? formatDate(res.data.createTime, "yyyy-MM-dd hh:mm:ss")
                : "";
              this.successTime = res.data.successTime
                ? formatDate(res.data.successTime, "yyyy-MM-dd hh:mm:ss")
                : "";
              resolve(res.data);
            } else {
              this.$toast(res.msg);
            }
          });
      });
    },
    //获取收货地址
    getReturnAddress() {
      return new Promise((resolve) => {
        this.$api.my.getReturnAdress().then((res) => {
          if (res.ret) {
            this.returnName = res.data.consignee;
            this.returnPhone = res.data.consigneePhone;
            this.returnAddress = res.data.addressInfo;

            resolve(res.data);
          } else {
            this.$toast(res.msg);
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.returnDetail-wrap-container {
  .returnDetail-wrap {
    background: rgba(244, 244, 244, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 15px;
    min-height: 100%;
    padding-top: 44px;
    .return-top-box {
      padding: 30px;
      color: rgba(255, 255, 255, 1);
      font-size: 13px;
      background: linear-gradient(
        90deg,
        rgba(220, 70, 65, 1) 0%,
        rgba(205, 0, 20, 1) 100%
      );
      display: flex;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      justify-content: center;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      line-height: 14px;
      flex-direction: column;
      -webkit-box-orient: vertical;
      -webkit-flex-direction: column;
      -ms-flex-direction: column;
      align-items: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      .return-status {
        display: flex;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        align-items: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        &-text {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 21px;
          margin-left: 7px;
        }
      }
      .return-note {
        margin-top: 12px;
      }
    }
    .flex-between {
      justify-content: space-between;
      -webkit-box-pack: space-between;
      -webkit-justify-content: space-between;
      -ms-flex-pack: space-between;
    }
    .card-box {
      padding: 20px;
      background: rgba(255, 255, 255, 1);
      &-title {
        font-size: 16px;
        line-height: 17px;
        display: flex;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        align-items: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        margin-bottom: 16px;
        padding-bottom: 15px;
        border-bottom: 1px solid rgba(242, 242, 242, 1);
      }
      .badge {
        font-size: 14px;
        color: rgba(153, 153, 153, 1);
        line-height: 15px;
        margin-left: 10px;
        position: relative;
      }
    }
    .card-box + .card-box {
      margin-top: 10px;
    }
    .info-list-box1,
    .info-list-box2 {
      p {
        line-height: 20px;
        color: rgba(51, 51, 51, 1);
      }
      p + p {
        margin-top: 8px;
      }
    }
    .info-list-box2 {
      p {
        color: rgba(102, 102, 102, 1);
      }
    }
    .silde-box {
      display: flex;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      align-items: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      color: rgba(102, 102, 102, 1);
      .silde-up-icon,
      .silde-down-icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url("../../assets/img/myPackage/arrow_lower_grey@2x.png")
          no-repeat right center;
        background-size: cover;
        margin-left: 4px;
      }
      .silde-down-icon {
        background: url("../../assets/img/myPackage/arrow_upper_grey@2x.png")
          no-repeat right center;
        background-size: cover;
      }
    }
    .return-address-box {
      padding-bottom: 50px;
      .return-address-title {
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
        display: flex;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        align-items: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        justify-content: space-between;
        -webkit-box-pack: space-between;
        -webkit-justify-content: space-between;
        -ms-flex-pack: space-between;

        margin-bottom: 8px;
        .return-address-name {
          font-weight: bold;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          flex: 1;
          -webkit-box-flex: 1;
          -webkit-flex: 1;
          -ms-flex: 1;
          margin-right: 3px;
        }
      }
    }
    .return_ing_icon,
    .return_success_icon {
      display: inline-block;
      width: 24px;
      height: 24px;
      background: url("../../assets/img/myPackage/return_ing_icon.png")
        no-repeat right center;
      background-size: cover;
    }
    .return_success_icon {
      background: url("../../assets/img/myPackage/return_success_icon.png")
        no-repeat right center;
      background-size: cover;
    }
    .logistics_return_icon {
      display: inline-block;
      width: 24px;
      height: 24px;
      background: url("../../assets/img/myPackage/logistics_return_red@2x.png")
        no-repeat right center;
      background-size: cover;
    }
    .logistics_collect_grey,
    .logistics_collect_red {
      display: inline-block;
      width: 24px;
      height: 24px;
      background: url("../../assets/img/myPackage/logistics_collect_grey@2x.png")
        no-repeat right center;
      background-size: cover;
    }
    .logistics_collect_red {
      background: url("../../assets/img/myPackage/logistics_collect_red@2x.png")
        no-repeat right center;
      background-size: cover;
    }
    .logistics_sign_gray,
    .logistics_sign_red {
      display: inline-block;
      width: 24px;
      height: 24px;
      background: url("../../assets/img/myPackage/logistics_sign_gray@2x.png")
        no-repeat right center;
      background-size: cover;
      position: relative;
      left: 1px;
    }
    .logistics_sign_red {
      background: url("../../assets/img/myPackage/logistics_sign_red@2x.png")
        no-repeat right center;
      background-size: cover;
    }
    .right-row {
      width: 16px;
      height: 16px;
      background: url("../../assets/img/myPackage/arrow_grey_school.png")
        no-repeat center center;
      background-size: cover;
    }
    .process-list {
      padding-left: 12px;
      li {
        padding-left: 22px;
        border-left: dashed 1px #e2e2e2;
      }
      li:last-of-type {
        border: none;
      }
      .process-title {
        display: flex;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        align-items: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        margin-left: -34px;
        margin-bottom: 4px;
        &-text {
          margin-left: 10px;
          display: flex;
          display: -webkit-box;
          display: -webkit-flex;
          display: -ms-flexbox;
          align-items: center;
          -webkit-box-align: center;
          -webkit-align-items: center;
          -ms-flex-align: center;
          flex: 1;
          -webkit-box-flex: 1;
          -webkit-flex: 1;
          -ms-flex: 1;
          label {
            font-size: 16px;
            font-weight: 500;
            color: rgba(153, 153, 153, 1);
            line-height: 17px;
            font-family: PingFangSC-Medium, PingFang SC;
          }
          a {
            font-size: 14px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 15px;
            display: flex;
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            align-items: center;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -ms-flex-align: center;
            .right-row {
              margin-left: 2px;
            }
          }
          &.success {
            label {
              color: rgba(51, 51, 51, 1);
            }
          }
        }
      }
      .process-info {
        padding-bottom: 20px;
        font-size: 14px;
        line-height: 15px;
        color: rgba(153, 153, 153, 1);
        p {
          display: flex;
          display: -webkit-box;
          display: -webkit-flex;
          display: -ms-flexbox;
          align-items: center;
          -webkit-box-align: center;
          -webkit-align-items: center;
          -ms-flex-align: center;
          padding: 5px 0;
          label {
            display: inline-block;
            width: 60px;
          }
          span {
            margin-left: 10px;
            color: rgba(102, 102, 102, 1);
          }
        }
      }
    }
    .font-size-min {
      font-size: 12px;
      font-weight: 400;
      line-height: 13px;
    }
  }
  .notrem-returnDetail-wrap-iphonex {
    padding-top: calc(1.17333rem + 40px);
  }
  .notrem-returnDetail-wrap-notiphonex {
    padding-top: calc(1.17333rem + 20px);
  }
}
.rewrite-am-navbar-light {
  color: #333;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 999;
  height: 44px;
  box-sizing: content-box;
  border-bottom: 1px solid #f3f3f3;
}
.notrem-rewrite-am-navbar-light-iphonex {
  padding-top: 40px;
}
.notrem-rewrite-am-navbar-light-notiphonex {
  padding-top: 20px;
}
</style>
